import {css} from '../theme/css'

export const classes = {
  clearIcon: css`
    cursor: pointer;
  `,
  hidden: css`
    visibility: hidden;
  `,
}
